import { Component, Input, OnInit } from '@angular/core';
import { FilterService } from '../../../services/filter/filter.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-filter-btn',
    templateUrl: './filter-btn.component.html',
    styleUrl: './filter-btn.component.scss',
    standalone: false
})
export class FilterBtnComponent implements OnInit {
  @Input() activeFiltersVisible: boolean = false;
  @Input() activeFiltersCount: number = 0;

  activeFilter: any;

  constructor(private filterService: FilterService, private router: Router
  ) {}

  ngOnInit(): void {
    const currentUrl = this.router.url; 
    this.activeFilter = this.filterService.getFilterState(currentUrl);
  }

  toggleFilter(): void {
    const currentUrl = this.router.url;
    this.filterService.toggleFilter(currentUrl);
  }

}
